import { render, staticRenderFns } from "./ViewCustomize.vue?vue&type=template&id=01e17b78&scoped=true&"
import script from "./ViewCustomize.vue?vue&type=script&lang=ts&"
export * from "./ViewCustomize.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCustomize.vue?vue&type=style&index=0&id=01e17b78&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e17b78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VTextarea})
